<template>
  <div>
    <section>
      <v-row class="px-4">
        <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
          <h1 v-if="tab === 0" :class="{'text-little': $vuetify.breakpoint.smAndDown}">Production</h1>
          <h1 v-else :class="{'text-little': $vuetify.breakpoint.smAndDown}">Production Schedule</h1>
        </v-col>
      </v-row>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="blue"
        grow
        slider-color="cyan accent-4"
      >
        <v-tab key="0">
          <v-icon class="mr-4">build</v-icon>
          Production
        </v-tab>
        <v-tab key="1">
          <v-icon class="mr-4">fas fa-table</v-icon>
          Production Schedule
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item :key="0">
          <v-card class="transparent elevation-0">
            <v-container container--fluid grid-list-md>
              <v-row :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                <v-col cols="12" sm="12" md="2">
                  <v-text-field
                    v-model="search"
                    label="Search..."
                    prepend-icon="fas fa-search"
                    clearable
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="1">
                </v-col>
                <v-col cols="6" md="1">
                  <div style="display: flex; justify-content: center; align-items: center">
                    <v-btn text @click="refresh" v-if="!loading">
                      <v-icon color="cyan darken-2">refresh</v-icon>
                    </v-btn>
                    <div v-if="loading" class="load-3">
                      <div class="line"></div>
                      <div class="line"></div>
                      <div class="line"></div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="4" md="2">
                </v-col>
                <v-col cols="4" md="2">
                  <v-autocomplete
                    label="Choose a depot..."
                    :items="renderedDepots"
                    item-text="name"
                    item-value="id"
                    v-model="depot"
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col cols="4" md="2">
                  <v-dialog
                    ref="dialogDate"
                    v-model="dateDialog"
                    :return-value.sync="date"
                    close-on-content-click
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label="Date ..."
                        v-on="on"
                        class="pb-4"
                        readonly
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="date" @input="$refs.dialogDate.save(date)">
                      <v-spacer></v-spacer>
                      <v-btn text color="blue darken-1" @click="dateDialog = false">Cancel</v-btn>
                      <v-btn text color="blue darken-1" @click="$refs.dialogDate.save(date)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="4" md="2">
                </v-col>
              </v-row>
            </v-container>

            <v-divider></v-divider>

            <v-data-table
              :headers="headers"
              :search="search"
              :loading="loading"
              :items="renderedProductions"
              class="elevation-1"
            >
              <template v-slot:item="{item}">
                <tr v-bind:class="{odd: item.index % 2, even: !item.index % 2}" >
                  <td style="text-align: center" v-if="header.text !== 'Actions'" v-for="(header, index) in headers" :key="index">
                    {{item[header.value]}}
                  </td>
                  <td v-else  class="text-center">
                    <v-tooltip top color="secondary">
                      <template v-slot:activator="{ on }">
                        <v-icon   color="blue" @click="download(item)" v-on="on">cloud_download</v-icon>
                      </template>
                      <span>Download CSV</span>
                    </v-tooltip>
                  </td>
                  <td v-else>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>

        </v-tab-item>

        <v-tab-item :key="1">
          <ProductionSchedule></ProductionSchedule>
          <v-divider></v-divider>
        </v-tab-item>
      </v-tabs-items>
    </section>

  </div>
</template>

<script>
import axios from "axios";
import ProductionSchedule from "./Production/ProductionSchedule.vue";

export default {
  components: {
    ProductionSchedule,
  },
  name: "ProductionPage",
  data (){
    return {
      tab: 0,
      tabRow: 0,
      search: '',
      loading: false,
      reload: false,
      isVisible: false,
      headers: [
        {text: 'Client', value: 'client_name', align: 'center', sortable: true},
        {text: 'Production Date', value: 'production_date', align: 'center', sortable: false},
        {text: 'Production Status', value: 'production_status', align: 'center', sortable: false},
        {text: 'Box Count', value: 'box_count', align: 'center', sortable: false},
        {text: 'Items Count', value: 'item_count', align: 'center', sortable: false},
        {text: 'Box Picked', value: 'boxes_picked', align: 'center', sortable: false},
        {text: 'Items Picked', value: 'items_picked', align: 'center', sortable: false},
        {text: 'Items OOS', value: 'items_OOS', align: 'center', sortable: false},
        {text: 'Actions', value: 'data-table-expand', align: 'center', sortable: false, width: '5%'},
      ],
      productionObj: null,
      productionId: null,
      climate: '',
      depot: null,
      date: null,
      dateDialog: false,
    }
  },
  methods:{
    refresh() {
      setTimeout(() => this.isVisible = false, 1000);
      this.isVisible = true;
      this.reload = !this.reload;
    },
    download(item){
      window.open(process.env.API_URL + '/picktolight/' + item.production_id +'/csv?key=' + encodeURI(this.$store.state.auth.key) + '&depot_id=' + this.depot.id, '_blank');
    },
    updateDataTable() {
      this.reload = !this.reload;
    }
  },
  computed: {
    isInternalUser() {
      return this.$store.getters['auth/isInternalUser'];
    },
    renderedProductions() {
      if (this.Productions === null || this.Productions === undefined){
        return [];
      } else {
        if(this.isInternalUser){
          return this.Productions;
        } else {
        const targetClientId = this.$store.getters['auth/client_id'];
        return this.Productions.filter((item) => {
          return item.client_id === targetClientId;
        });
       }
      }
    },
    renderedDepots(){
      if (this.depots === null || this.depots === undefined) {
        return [];
      } else {
        return this.depots;
      }
    },
  },
  asyncComputed: {
    async Productions() {
      if (this.reload || !this.reload) {
        this.loading = true;
        if(this.depot !== null && this.date !== null) {
          return await axios.get(process.env.API_URL + '/picktolight?depot_id=' + this.depot.id
            + '&date=' + this.date)
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$store.commit('displaySnackbar', 'ERROR ' + error.response.data.error);
            });
        }
      }
    },
    async depots() {
      return await axios.get(process.env.API_URL +'/depots')
        .then((response) => {
          if (response.status === 200) {
            return response.data.sort((a, b) => (a.name > b.name) ? 1 : -1);
          } else {
            return [];
          }
        })
        .catch((error) => {
          return [];
        });
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Production.vue